import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {User} from '../../user/user';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { AppSettings } from '../../app.settings';

@Injectable()
export class AuthService {
  token: string;
  authurl=AppSettings.API_ENDPOINT+"validateLogin";
  userDetailsUrl=AppSettings.API_ENDPOINT+"user/email";
  constructor(private http:Http) {}

  signupUser(email: string, password: string) {
    //your code for signing up the new user
  }

  signinUser(model:User) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
       return this.http.post(this.authurl, JSON.stringify(model),options)
       .map(res=>res.json())
    //your code for checking credentials and getting tokens for for signing in user
   
  
  }

  getUserDetails(userid:string): Observable<any>{
    return this.http.get(this.userDetailsUrl+"?email="+userid).map(res=>res.json());

}


  logout() {   
        sessionStorage.clear();
  }

  getToken() {    
    return this.token;
  }

  isAuthenticated() {
    // here you can check if user is authenticated or not through his token 
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts